/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  setPartnerStatusModalStaus,
  setFiles,
  setPartnerDetails,
  setPartnerShowModalStatus,
} from "../../../../redux/features/shared/sharedSlice";
import { Button } from "react-bootstrap";
import { LANG } from "../../../constants/language";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MIME_TYPE_MAP } from "../../../constants/utlis";


function PartnerDetailsModal() {
  const dispatch: any = useDispatch();
  let sharedActions: any = useSelector((state: any) => state?.sharedActions);
  const fileUrl = process.env.REACT_APP_FILE_URL;

  const closeModal = () => {
    dispatch(setPartnerShowModalStatus(false));
    dispatch(setPartnerDetails({}));
    dispatch(setFiles([]));
  };

  const updateStatus = (status: string) => {
    let updatedPartnerData = { ...sharedActions?.partnerDetails };
    updatedPartnerData.updatedStatus = status;
    dispatch(setPartnerDetails(updatedPartnerData));

    dispatch(setPartnerShowModalStatus(false));
    dispatch(setPartnerStatusModalStaus(true));
  };

  const sliderRef = useRef<Slider | null>(null);

  useEffect(() => {
    if (sharedActions?.partnerDetails?.locations?.length) {
      const updatedLocations = sharedActions.partnerDetails.locations.map((location) => {
        if (location?.images?.length) {
          const previewImgArr = location.images.map((item: any) => {
            if (!item?.type) {
              const extension = item.split('.').pop().toLowerCase();
              const mimeType = MIME_TYPE_MAP[extension] || 'application/octet-stream';
              return { preview: item, type: mimeType };
            }
            return item; // Already formatted
          });

          // Return updated location object
          return { ...location, images: previewImgArr };
        }
        return location; // No images to update
      });

      // Avoid redundant dispatch if locations are already formatted
      const isUpdated = JSON.stringify(sharedActions.partnerDetails.locations) === JSON.stringify(updatedLocations);
      if (!isUpdated) {
        dispatch(setPartnerDetails({ ...sharedActions.partnerDetails, locations: updatedLocations }));
      }
    }

    if (sliderRef?.current) {
      sliderRef.current.slickGoTo(0);
    }
  }, [sharedActions.partnerDetails, dispatch]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
  };

  return (
    <>
      <Modal
        className="wrapmodal"
        backdrop="static"
        size="lg"
        show={sharedActions?.partnerShowDetailsModal}
        onHide={closeModal}
        animation={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Partner Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="wrapmodalInner">
            <div className="row mb-4">
              <div className="col-md-12">
                <div className="half50">
                  <p>
                    <strong>Name:</strong>{" "}
                    {sharedActions?.partnerDetails?.name || "N/A"}
                  </p>
                  <p>
                    <strong>Business Name:</strong>{" "}
                    {sharedActions?.partnerDetails?.businessName || "N/A"}
                  </p>
                  <p>
                    <strong>Email:</strong>{" "}
                    {sharedActions?.partnerDetails?.email || "N/A"}
                  </p>
                  <p>
                    <strong>Business Website:</strong>{" "}
                    {sharedActions?.partnerDetails?.businessWebsite ? <a target="blank" href={sharedActions?.partnerDetails?.businessWebsite}> {sharedActions?.partnerDetails?.businessWebsite}</a> : "N/A"}
                  </p>
                  <p>
                    <strong>Phone Number:</strong>{" "}
                    {sharedActions?.partnerDetails?.phone || "N/A"}
                  </p>
                  <p>
                    <strong>Business Category:</strong>{" "}
                    <span className="textCap">{sharedActions?.partnerDetails?.businessType?.name || "N/A"}</span>
                  </p>
                  <p>
                    <strong>Check-in Rate:</strong>{" "}
                    {sharedActions?.partnerDetails?.checkinRate || "N/A"}
                  </p>
                  <p></p>

                  {/* <p>
                    <strong>Status:</strong>{" "}
                    <span className="textCap">{sharedActions?.partnerDetails?.status || "N/A"}</span>
                  </p> */}

                  <h4>{LANG.LOCATIONS}</h4>
                  {sharedActions?.partnerDetails?.locations?.length ? (
                    sharedActions?.partnerDetails?.locations.map((location, index) => (
                      <div key={index} className="location-section">
                        <p>
                          <strong>{LANG.ADDRESS}:</strong> {location?.address || "N/A"}
                        </p>
                        <p>
                          <strong>Business Offering Services:</strong>
                          <span className="textCap">{location?.serviceNames?.join(", ") || "N/A"}</span>
                        </p>
                        <p>
                          <strong>{LANG.BUSINESS_START_TIME}:</strong> {location?.startTime || "N/A"}
                        </p>
                        <p>
                          <strong>{LANG.BUSINESS_END_TIME}:</strong> {location?.endTime || "N/A"}
                        </p>

                        {/* <div
                          style={{
                            background: "#fff",
                            padding: "20px",
                            borderRadius: "8px",
                            width: "100%",
                          }}
                        >
                          {location?.images?.length ? (
                            <Slider {...settings} ref={sliderRef}>
                              {location?.images.map(({ preview, type }: any, index: any) => (
                                <div key={index} className="location-section">
                                  <div>
                                    {type?.startsWith("video") ? (
                                      <video
                                        src={fileUrl + preview}
                                        controls
                                        className="w-100"
                                      />
                                    ) : (
                                      <img
                                        src={fileUrl + preview}
                                        alt={`Preview ${index}`}
                                        className="w-100"
                                      />
                                    )}
                                  </div>
                                </div>
                              ))}
                            </Slider>
                          ) : (
                            <p style={{ textAlign: "center", width: "100%", display: "block" }}>{LANG.NO_LOCATION_IMAGES}</p> // Fallback message if no locations
                          )}
                        </div> */}

                      </div>
                    ))
                  ) : (
                    <p style={{ textAlign: "center", width: "100%", display: "block" }}>
                      {LANG.NO_LOCATIONS_AVAILABLE}
                    </p> // Fallback message if no locations
                  )}

                </div>
              </div>
            </div>
          </div>

          <Modal.Footer>
            {sharedActions?.partnerDetails?.status?.toLowerCase() !== "accepted" && sharedActions?.partnerDetails?.status?.toLowerCase() !== "rejected" && (
              <Button
                type="button"
                variant="danger"
                className="secondaryBtn"
                onClick={() => updateStatus("rejected")}
              >
                Reject
              </Button>
            )}

            {sharedActions?.partnerDetails?.status?.toLowerCase() !== "accepted" && (
              <Button
                type="submit"
                className="primaryBtn active"
                onClick={() => updateStatus("accepted")}
              >
                Accept
              </Button>
            )}

          </Modal.Footer>

        </Modal.Body>
      </Modal>
    </>
  );
}

export { PartnerDetailsModal };
